import re_pescatore_1996 from "../assets/archive_images/1996_re_pescatore.jpeg";
import billy_budd_1997 from "../assets/archive_images/1997_billy_budd.JPG";
import uomo_che_vide_1998 from "../assets/archive_images/1998_uomo_che_vide.jpg";
import casina_1998 from "../assets/archive_images/1998_casina.jpg";
import prostitute_1998 from "../assets/archive_images/1998_prostitute.jpg";
import donna_ragusa_1998 from "../assets/archive_images/1998_la_donna_di_ragusa.jpg";
import casina_1999 from "../assets/archive_images/1999_casina.jpg";
import mostellaria_prima_1999 from "../assets/archive_images/1999_mostellaria_prima.jpg";
import avaro_2000 from "../assets/archive_images/2000_avaro.jpg";
import menecmi_2000 from "../assets/archive_images/2000_menecmi.jpg";
import pluto_2000 from "../assets/archive_images/2000_pluto.jpg";
import curtigghiu_2001 from "../assets/archive_images/2001_lu_curtigghiu.jpg";
import pluto_2001 from "../assets/archive_images/2001_pluto.jpg";
import curtigghiu_2002 from "../assets/archive_images/2002_lu_curtigghiu.jpg";
import aulularia_2002 from "../assets/archive_images/2002_aulularia.jpg";
import locandiera_2003 from "../assets/archive_images/2003_la_locandiera.jpg";
import homeide_2004 from "../assets/archive_images/2004_homeide.jpg";
import ospiti_castello_2004 from "../assets/archive_images/2004_ospiti_castello.jpg";
import personaggi_2005 from "../assets/archive_images/2005_personaggi_autore.jpeg";
import sogno_notte_2005 from "../assets/archive_images/2005_sogno_notte_mezza_estate.jpg";
import zum_zum_2005 from "../assets/archive_images/2005_zum_zum_zum.jpg";
import mostellaria_seconda_2005 from "../assets/archive_images/2005_mostellaria_seconda.jpg";
import bottega_caffe_2005 from "../assets/archive_images/2005_bottega_caffe.jpg";
import commedia_errori_2006 from "../assets/archive_images/2006_commedia_errori.JPG";
import sogno_notte_2006 from "../assets/archive_images/2006_sogno_notte_mezza_estate.jpg";
import nuvole_2006 from "../assets/archive_images/2006_le_nuvole.jpg";
import miseria_2006 from "../assets/archive_images/2006_miseria_nobilta_prima.jpg";
import nemici_intimi_2007 from "../assets/archive_images/2007_nemici_intimi.jpg";
import romeo_giulietta_2007 from "../assets/archive_images/2007_romeo_giulietta.jpg";
import amleto_2007 from "../assets/archive_images/2007_amleto.jpg";
import romeo_giulietta_2008 from "../assets/archive_images/2008_romeo_giulietta.jpg";
import fuggitive_2009 from "../assets/archive_images/2009_le_fuggitive_prima.jpg";
import dodicesima_notte_2009 from "../assets/archive_images/2009_dodicesima_notte.jpg";
import classe_ferro_2009 from "../assets/archive_images/2009_classe_ferro.jpg";
import menecmi_2009 from "../assets/archive_images/2009_menecmi.jpg";
import commedia_errori_2010 from "../assets/archive_images/2010_commedia_errori.jpg";
import medea_medeas_2010 from "../assets/archive_images/2010_medea_medeas.jpg";
import miseria_2011 from "../assets/archive_images/2011_miseria_nobilta_seconda.jpg";
import intrisi_2011 from "../assets/archive_images/2011_intrisi_delle_cose.jpg";
import berretto_prima_2012 from "../assets/archive_images/2012_berretto_sonagli_prima.jpg";
import berretto_seconda_2012 from "../assets/archive_images/2012_berretto_sonagli_seconda.jpg";
import medeia_2012 from "../assets/archive_images/2012_medeia_medeias.jpg";
import tartufo_2013 from "../assets/archive_images/2013_tartufo.jpg";
import fumo_occhi_2013 from "../assets/archive_images/2013_fumo_negli_occhi.jpg";
import fuggitive_seconda_2014 from "../assets/archive_images/2014_le_fuggitive_seconda.jpg";

const SHOWS_ARCHIVE = [
  {
    id: "show_id_045",
    year: 2014,
    title: "Le fuggitive",
    author: "Pierre Palmade E Christophe Duthuron",
    image: fuggitive_seconda_2014,
  },
  {
    id: "show_id_043",
    year: 2013,
    title: "Tartufo",
    author: "Moliere",
    image: tartufo_2013,
  },
  {
    id: "show_id_044",
    year: 2013,
    title: "Fumo negli occhi",
    author: "Faele E Romano",
    image: fumo_occhi_2013,
  },
  {
    id: "show_id_040",
    year: 2012,
    title: "Berretto a sonagli",
    author: "Luigi Pirandello",
    image: berretto_prima_2012,
  },
  {
    id: "show_id_041",
    year: 2012,
    title: "Berretto a sonagli",
    author: "Luigi Pirandello",
    image: berretto_seconda_2012,
  },
  {
    id: "show_id_042",
    year: 2012,
    title: "Medeia, Medeias, Medeia",
    author: "Euripide",
    image: medeia_2012,
  },
  {
    id: "show_id_038",
    year: 2011,
    title: "Miseria e Nobilta",
    author: "Eduardo Scarpetta",
    image: miseria_2011,
  },
  {
    id: "show_id_039",
    year: 2011,
    title: "Intrisi delle stesse cose",
    author: "Autori Vari",
    image: intrisi_2011,
  },
  {
    id: "show_id_036",
    year: 2010,
    title: "La commedia degli errori",
    author: "William Shakespeare",
    image: commedia_errori_2010,
  },
  {
    id: "show_id_037",
    year: 2010,
    title: "Medea, Medeas, Medeam",
    author: "Munus",
    image: medea_medeas_2010,
  },
  {
    id: "show_id_032",
    year: "2009/13",
    title: "Le fuggitive",
    author: "Pierre Palmade E Christophe Duthuron",
    image: fuggitive_2009,
  },
  {
    id: "show_id_033",
    year: 2009,
    title: "La dodicesima notte",
    author: "William Shakespeare",
    image: dodicesima_notte_2009,
  },
  {
    id: "show_id_034",
    year: 2009,
    title: "Classe di ferro",
    author: "Aldo Nicolaj",
    image: classe_ferro_2009,
  },
  {
    id: "show_id_035",
    year: 2009,
    title: "Menecmi",
    author: "Tito Maccio Plauto",
    image: menecmi_2009,
  },
  {
    id: "show_id_031",
    year: 2008,
    title: "Romeo e Giulietta",
    author: "William Shakespeare",
    image: romeo_giulietta_2008,
  },
  {
    id: "show_id_028",
    year: 2007,
    title: "Nemici intimi",
    author: "Mario Scaletta",
    image: nemici_intimi_2007,
  },
  {
    id: "show_id_029",
    year: 2007,
    title: "Romeo e Giulietta",
    author: "William Shakespeare",
    image: romeo_giulietta_2007,
  },
  {
    id: "show_id_030",
    year: 2007,
    title: "Amleto",
    author: "William Shakespeare",
    image: amleto_2007,
  },
  {
    id: "show_id_027",
    year: "2006/07",
    title: "Miseria e Nobiltà",
    author: "Eduardo Scarpetta",
    image: miseria_2006,
  },
  {
    id: "show_id_024",
    year: 2006,
    title: "La commedia degli errori",
    author: "William Shakespeare",
    image: commedia_errori_2006,
  },
  {
    id: "show_id_025",
    year: 2006,
    title: "Sogno di una notte di mezza estate",
    author: "William Shakespeare",
    image: sogno_notte_2006,
  },
  {
    id: "show_id_026",
    year: 2006,
    title: "Le nuvole",
    author: "Aristofane",
    image: nuvole_2006,
  },
  {
    id: "show_id_019",
    year: 2005,
    title: "Sei personaggi in cerca dautore",
    author: "Luigi Pirandello",
    image: personaggi_2005,
  },
  {
    id: "show_id_020",
    year: 2005,
    title: "Sogno di una notte di mezza estate",
    author: "William Shakespeare",
    image: sogno_notte_2005,
  },
  {
    id: "show_id_021",
    year: 2005,
    title: "Zum zum zum",
    author: "Roberto Biondi",
    image: zum_zum_2005,
  },
  {
    id: "show_id_022",
    year: 2005,
    title: "Mostellaria",
    author: "Tito Maccio Plauto",
    image: mostellaria_seconda_2005,
  },
  {
    id: "show_id_023",
    year: 2005,
    title: "La bottega del caffè",
    author: "Carlo Goldoni",
    image: bottega_caffe_2005,
  },
  {
    id: "show_id_017",
    year: 2004,
    title: "Homeide",
    author: "Vianello E Minghi",
    image: homeide_2004,
  },
  {
    id: "show_id_018",
    year: 2004,
    title: "Gli ospiti di quel castello",
    author: "Ercole Patti",
    image: ospiti_castello_2004,
  },
  {
    id: "show_id_016",
    year: 2003,
    title: "La locandiera",
    author: "Carlo Goldoni",
    image: locandiera_2003,
  },
  {
    id: "show_id_014",
    year: 2002,
    title: "Lu curtigghiu di li raunisi",
    author: "Ignazio Buttita",
    image: curtigghiu_2002,
  },
  {
    id: "show_id_015",
    year: 2002,
    title: "Aulularia",
    author: "Tito Maccio Plauto",
    image: aulularia_2002,
  },
  {
    id: "show_id_012",
    year: 2001,
    title: "Lu curtigghiu di li raunisi",
    author: "Ignazio Buttita",
    image: curtigghiu_2001,
  },
  {
    id: "show_id_013",
    year: 2001,
    title: "Pluto",
    author: "Aristofane",
    image: pluto_2001,
  },
  {
    id: "show_id_009",
    year: 2000,
    title: "Avaro",
    author: "Moliere",
    image: avaro_2000,
  },
  {
    id: "show_id_010",
    year: 2000,
    title: "Menecmi",
    author: "Tito Maccio Plauto",
    image: menecmi_2000,
  },
  {
    id: "show_id_011",
    year: 2000,
    title: "Pluto",
    author: "Aristofane",
    image: pluto_2000,
  },
  {
    id: "show_id_007",
    year: 1999,
    title: "Casina",
    author: "Tito Maccio Plauto",
    image: casina_1999,
  },
  {
    id: "show_id_008",
    year: 1999,
    title: "Mostellaria",
    author: "Tito Maccio Plauto",
    image: mostellaria_prima_1999,
  },
  {
    id: "show_id_004",
    year: 1998,
    title: "Casina",
    author: "Tito Maccio Plauto",
    image: casina_1998,
  },
  {
    id: "show_id_005",
    year: 1998,
    title: "Le prostitute vi precederanno nel regno dei cieli",
    author: "Jose Martin Descalzo",
    image: prostitute_1998,
  },
  {
    id: "show_id_006",
    year: 1998,
    title: "La donna di Ragusa",
    author: "Maria Occhipinti",
    image: donna_ragusa_1998,
  },
  {
    id: "show_id_003",
    year: 1998,
    title: "L'uomo che vide",
    author: "Joseph Delteil",
    image: uomo_che_vide_1998,
  },
  {
    id: "show_id_002",
    year: 1997,
    title: "Billy Budd",
    author: "Herman Melville",
    image: billy_budd_1997,
  },
  {
    id: "show_id_001",
    year: 1996,
    title: "Il Re Pescatore",
    author: "Julien Gracq",
    image: re_pescatore_1996,
  },
];

export default SHOWS_ARCHIVE;
